import { ROOT_STATUS } from "."

export const TYPES = {
  TYPE_NEW_CARD: 'NEW_CARD',
  TYPE_EXISTING_CARD: 'EXISTING_CARD',
}

export const STRIPE = {
  PAYMENT_INTENT: {
    STATUS_PROCESSING: 'processing',
    STATUS_SUCCEED: 'succeeded',
    STATUS_PAYMENT_FAILED: 'payment_failed',
    STATUS_AMOUNT_CAPTURABLE_UPDATED: 'amount_capturable_updated',
  }
}

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_OPEN : {
    key: 'STATUS_CREATED',
    value: 'Open',
    color: 'secondary',
    icon: '',
  },
  STATUS_CREATED : {
    key: 'STATUS_OPEN',
    value: 'Created',
    color: 'secondary',
    icon: '',
  },
  STATUS_SUCCEED : {
    key: 'STATUS_SUCCEED',
    value: 'Succeed',
    color: 'success',
    icon: '',
  },
  STATUS_FAILED : {
    key: 'STATUS_FAILED',
    value: 'Failed',
    color: 'error',
    icon: '',
  },
  STATUS_EXCEPTION : {
    key: 'STATUS_EXCEPTION',
    value: 'Exception',
    color: 'error',
    icon: '',
  },
}

export const METHODS = {
  INVOICE : {
    key: 'INVOICE',
    value: 'Business Account',
    color: 'secondary',
    icon: '',
  },
  PREPAID : {
    key: 'PREPAID',
    value: 'Credit Card',
    color: 'primary',
    icon: '',
  },
  SYSTEM : {
    key: 'SYSTEM',
    value: 'System',
    color: 'warning',
    icon: '',
  },
  INSTALLMENT : {
    key: 'INSTALLMENT',
    value: 'Instalment',
    color: 'succeed',
    icon: '',
  },
}

export const PAYMENT_GATEWAYS = {
  GATEWAY_STRIPE : {
    key: 'GATEWAY_STRIPE',
    value: 'Stripe',
    color: 'primary',
    icon: '',
  },
}

export const SERVICE_PAYMENT_STATUSES = {
  ...ROOT_STATUS,
  STATUS_OUTSTANDING : {
    key: 'STATUS_OUTSTANDING',
    value: 'Pending',
    color: 'primary',
    icon: '',
  },
  STATUS_ON_INSTALLMENT : {
    key: 'STATUS_ON_INSTALLMENT',
    value: 'On Instalment',
    color: 'primary',
    icon: '',
  },
  STATUS_ON_INSTALLMENT_OVERDUE : {
    key: 'STATUS_ON_INSTALLMENT_OVERDUE',
    value: 'On Instalment - Occur Overdue',
    color: 'error',
    icon: '',
  },
  STATUS_INSTALLMENT_COMPLETED : {
    key: 'STATUS_INSTALLMENT_COMPLETED',
    value: 'Instalment Completed',
    color: 'success',
    icon: '',
  },
  STATUS_UNPAID : {
    key: 'STATUS_UNPAID',
    value: 'Unpaid',
    color: 'secondary',
    icon: '',
  },
  STATUS_PAID : {
    key: 'STATUS_PAID',
    value: 'Paid',
    color: 'success',
    icon: '',
  },
  STATUS_CANCELLED : {
    key: 'STATUS_CANCELLED',
    value: 'Cancelled',
    color: 'dark',
    icon: '',
  },
  STATUS_OVERDUE : {
    key: 'STATUS_OVERDUE',
    value: 'Overdue',
    color: 'error',
    icon: '',
  },
}

export const SERVICE_PAYMENT_INSTALLMENT_STATUSES = {
  ...ROOT_STATUS,
  STATUS_OUTSTANDING : {
    key: 'STATUS_OUTSTANDING',
    value: 'Payment Required',
    color: 'primary',
    icon: '',
  },
  STATUS_ON_INSTALLMENT : {
    key: 'STATUS_ON_INSTALLMENT',
    value: 'On Instalment',
    color: 'primary',
    icon: '',
  },
  STATUS_ON_INSTALLMENT_OVERDUE : {
    key: 'STATUS_ON_INSTALLMENT_OVERDUE',
    value: 'On Instalment - Occur Overdue',
    color: 'error',
    icon: '',
  },
  STATUS_INSTALLMENT_COMPLETED : {
    key: 'STATUS_INSTALLMENT_COMPLETED',
    value: 'Instalment Completed',
    color: 'success',
    icon: '',
  },
  STATUS_UNPAID : {
    key: 'STATUS_UNPAID',
    value: 'Current',
    color: 'secondary',
    icon: '',
  },
  STATUS_PAID : {
    key: 'STATUS_PAID',
    value: 'Paid',
    color: 'success',
    icon: '',
  },
  STATUS_CANCELLED : {
    key: 'STATUS_CANCELLED',
    value: 'Cancelled',
    color: 'dark',
    icon: '',
  },
  STATUS_OVERDUE : {
    key: 'STATUS_OVERDUE',
    value: 'Overdue',
    color: 'error',
    icon: '',
  },
}

export const INVOICE_STATUSES = {
  ...ROOT_STATUS,
  INVOICE_STATUS_SUCCEED : {
    key: 'invoice-succeed',
  },
  INVOICE_STATUS_INSUFFICIENT_CREDIT : {
    key: 'invoice-insufficient-credit',
  },
  INVOICE_STATUS_UNAUTHORIZED : {
    key: 'invoice-unauthorized',
  },
}